
export default {
  components: {
    LedSearchForm: () => import('./LedSearchForm'),
  },
  props: {
    brand: {
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    allExcludedVehicles() {
      const excludedVehicles = [...this.product.vehicles_excluded]

      // Ajouter les marques entièrement exclues
      this.product.vehicle_brands_excluded.forEach(brand => {
        if (!excludedVehicles.some(v => v.brand?.name === brand.name)) {
          excludedVehicles.push({
            brand: brand, // Garder l'objet brand complet avec son slug
            name: 'Tous',
            id: null,
          })
        }
      })

      return excludedVehicles
        .map(vehicle => ({
          brand:
            vehicle.brand?.name ||
            this.$t('components.compatibilityList.notSpecified'),
          model:
            vehicle.name ||
            this.$t('components.compatibilityList.notSpecified'),
          year_from: vehicle.year_from,
          year_to: vehicle.year_to,
          id: vehicle.id,
          vehicle_data: vehicle, // Garder les données originales pour le lien
        }))
        .sort((a, b) => {
          const brandComparison = a.brand.localeCompare(b.brand, 'fr', {
            sensitivity: 'base',
          })
          return brandComparison !== 0
            ? brandComparison
            : a.model.localeCompare(b.model, 'fr', { sensitivity: 'base' })
        })
    },
  },
  methods: {
    openModal() {
      this.$bvModal.show('modalSearchLedBlog')
    },

    formatYearRange(yearFrom, yearTo) {
      if (!yearFrom && !yearTo) {
        return this.$t('components.compatibilityList.notSpecified')
      }
      if (!yearFrom) return `- ${yearTo}`
      if (!yearTo) return `${yearFrom} -`
      if (yearFrom === yearTo) return yearFrom
      return `${yearFrom} - ${yearTo}`
    },

    getUrl(vehicle) {
      if (!vehicle || !vehicle.id || vehicle.model === 'Tous') {
        return '#'
      }

      // Utiliser les données du véhicule original pour créer le lien correct
      const vehicleData = vehicle.vehicle_data || vehicle

      // Gérer correctement la marque (soit un objet avec name, soit une chaîne)
      const brandName =
        vehicleData.brand?.name || vehicleData.brand || vehicle.brand
      const modelName = vehicleData.name || vehicle.model
      const vehicleId = vehicleData.id || vehicle.id

      return this.localePath({
        name: 'recherche-led-accessoires-brand-type-typeid',
        params: {
          brand: this.$slugify(brandName).toLowerCase(),
          type: this.$slugify(modelName).toLowerCase(),
          typeid: vehicleId,
        },
      })
    },

    getBrandUrl(vehicle) {
      if (!vehicle || !vehicle.brand) {
        return null
      }

      const vehicleData = vehicle.vehicle_data || vehicle
      const brandSlug = vehicleData.brand?.slug

      if (!brandSlug) {
        return null
      }

      return this.localePath({
        name: 'marques-vehicules-slug',
        params: {
          slug: brandSlug,
        },
      })
    },
  },
}
